export default __webpack_public_path__ + "static/media/user.bfd65d54.png";